import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'costmaterialtransportation',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `costmaterialtransportation`,
    method: 'get',
    params: queriesParams
  })
}

export function addCostMaterialTransportation (costMaterialTransportation) {
  return request({
    method: 'post',
    url: 'costmaterialtransportation',
    data: costMaterialTransportation
  })
}

export function show (id) {
  return request({
    url: `costmaterialtransportation/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `costmaterialtransportation/${id}`,
    method: 'patch',
    data
  })
}

export function generateReport(queriesParams) {
  return request({
    url: `costmaterialtransportation/report`,
    method: 'get',
    params: queriesParams
  })
}

export function deleteCost (id) {
  return request({
    url: `costmaterialtransportation/${id}`,
    method: 'delete'
  })
}
